/**
 * abilityVfxRicochetSpark — Sivir W Ricochet crossblade empower (SP-18).
 */
export function buildRicochetSpark(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.5 * (spec.scale || 1.25);
  const gold = mat(THREE, spec.color || 0xfcd34d, 0.92);
  const jewel = mat(THREE, 0xfef08a, 0.98);
  addHubBlade(THREE, group, s, gold, jewel);
  addBounceArcs(THREE, group, s, gold, jewel);
  addFootRing(THREE, group, s, gold);
  group.userData = { shape: 'ricochet_spark' };
  return group;
}

function addHubBlade(THREE, group, s, gold, jewel) {
  const arm = new THREE.Mesh(new THREE.BoxGeometry(0.9 * s, 0.06 * s, 0.16 * s), gold);
  arm.position.y = 0.55 * s;
  group.add(arm);
  const cross = new THREE.Mesh(new THREE.BoxGeometry(0.16 * s, 0.06 * s, 0.75 * s), gold);
  cross.position.y = 0.55 * s;
  group.add(cross);
  const gem = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), jewel);
  gem.position.y = 0.6 * s;
  group.add(gem);
}

function addBounceArcs(THREE, group, s, gold, jewel) {
  for (let i = 0; i < 3; i += 1) {
    const ang = (Math.PI * 2 / 3) * i;
    const spark = new THREE.Mesh(new THREE.BoxGeometry(0.06 * s, 0.06 * s, 0.55 * s), gold);
    spark.position.set(Math.cos(ang) * 0.55 * s, 0.45 * s, Math.sin(ang) * 0.55 * s);
    spark.rotation.y = ang;
    group.add(spark);
    const tip = new THREE.Mesh(new THREE.ConeGeometry(0.07 * s, 0.18 * s, 5), jewel);
    tip.position.set(Math.cos(ang) * 0.9 * s, 0.45 * s, Math.sin(ang) * 0.9 * s);
    group.add(tip);
  }
}

function addFootRing(THREE, group, s, gold) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.4, s * 1.05, 20).rotateX(-Math.PI / 2),
    gold
  );
  ring.position.y = 0.06;
  group.add(ring);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
